import React from 'react';
import { Col, Form } from 'react-bootstrap';

// TextInput
const TextInput = ({ c, i, valuesRequired, handleInputChange }) => {
  return (
    <Col lg={6} xs={12} className="mb-3" key={'form-bodyform-' + i}>
      <Form.Group controlId={'validationCustom' + i}>
        <Form.Label>
          {c.required ? c.name + ' *' : c.name + ' (opcional)'}
        </Form.Label>
        <Form.Control
          name={!c.required ? '_' + c.name : c.name}
          type="text"
          autoComplete="off"
          minLength={c.required ? 3 : 0}
          required={c.required}
          placeholder={c.placeholder}
          onChange={handleInputChange}
          isValid={
            (c.required &&
              valuesRequired.content[c.name] !== undefined &&
              valuesRequired.content[c.name].length > 2) ||
            (!c.required &&
              valuesRequired.content['_' + c.name] !== undefined &&
              valuesRequired.content['_' + c.name].length > 2)
          }
          isInvalid={
            c.required &&
            valuesRequired.content[c.name]?.length > 0 &&
            valuesRequired.content[c.name]?.length <= 2
          }
        />
        <Form.Control.Feedback type="invalid">
          Ingrese un {c.name} por favor
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );
};

export default TextInput;
